import {
  type FilterFields,
  useLedgerEntriesTable,
} from "./use-ledger-entries-table";

import type { RawFilters } from "@/hooks/useQueryFilters";
import { Table } from "./table";

type Props = {
  tableName: string;
  queryKeyPrefix: string;
  storageKey?: string;
  query?: RawFilters<FilterFields>;
};

export const LedgerEntriesTable = ({
  tableName,
  queryKeyPrefix,
  storageKey,
  query,
}: Props) => {
  const table = useLedgerEntriesTable({
    tableName,
    queryKeyPrefix,
    storageKey,
    defaultFilters: query,
  });

  return <Table {...table} />;
};
